module.exports = __webpack_public_path__ + "static/media/icon_informativo.92d03f2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_informativo.svg
// module id = 523
// module chunks = 0